export default "__VITE_ASSET__BgiwoB12__"